import React from 'react';

interface RightArrowIconProps {
    color: string;
}

const RightArrowIcon = (props: RightArrowIconProps): React.JSX.Element => {
    const { color } = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className="breadcrumb-arrow"
        >
            <path
                d="M9.29762 7.99964L6.23096 4.93297L6.93346 4.23047L10.7026 7.99964L6.93346 11.7688L6.23096 11.0663L9.29762 7.99964Z"
                fill={color}
                data-testid="right-arrow-icon-color"
            />
        </svg>
    );
};

export default RightArrowIcon;
